import React, { FC } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { THEME_PRIMARY, themeColor } from '../../styles/basics/colors';
import MaterialIcon from '../common/MaterialIcon';
import { MATERIAL_ICON_CAMPAIGNS } from '../common/Button/Icon';
import { LoanFormat, mapLoanFormat } from '../../../models/LoanFormat';
import { Trans, useTranslation } from 'react-i18next';

const StMaterialIcon = styled(MaterialIcon)`
    margin-right: 2px;
    vertical-align: text-top;
`;

const StLink = styled(Link)`
    font-size: 11px;
    color: ${themeColor(THEME_PRIMARY)} !important;
    font-weight: bold;
    &:hover {
        color: ${themeColor(THEME_PRIMARY)} !important;
    }
`;

type Props = {
    readonly loanFormat: LoanFormat;
    readonly className?: string;
};

const ProductCampaignLabel: FC<Props> = props => {
    const { t } = useTranslation();

    return (
        <div className={props.className}>
            <StLink to="/unlimited/campaigns/all">
                <Trans
                    i18nKey="shop.campaigns.productCampaignLabel"
                    values={{
                        loanFormat: t(`loanFormat.plain.${mapLoanFormat(props.loanFormat)?.toLowerCase()}`, {
                            count: 1
                        })
                    }}
                    components={[<StMaterialIcon icon={MATERIAL_ICON_CAMPAIGNS} />]}
                />
            </StLink>
        </div>
    );
};

export default ProductCampaignLabel;
